export const whiteListGuideData = [
  {
    title: "WELCOME",
    popupTitle: "add, remove, be the NFT dictator!",
    subTitle:
      "<span class='text-primary-blue'>WHITELIST</span> is a dynamic list of addresses for minting NFT or SBT, which the founder can modify by adding or removing up to 70 wallets in a single transaction. ",
  },
  {
    title: "GUIDE",
    data: [
      {
        popupTitle: "Add addresses — build your chosen army!",
        subTitle:
          "HOW TO ADD USERS TO THE WHITELIST: <span class='text-primary-orange'>STEP 1</span>",
        subContent: [
          "Go to the “<span class='text-primary-orange'>Eligible</span>” tab, upload your TXT wallet list (one wallet per line), then click “<span class='text-primary-orange'>Sync with Requests</span>”",
        ],
      },
      {
        popupTitle: "Select up to 70 lucky ones and add them to the whitelist!",
        subTitle:
          "HOW TO ADD USERS TO THE WHITELIST: <span class='text-primary-orange'>STEP 2</span>",
        subContent: [
          "In the “<span class='text-primary-orange'>Requests</span>” tab, select up to <span class='text-primary-red'>70</span> wallets and click “<span class='text-primary-orange'>Add Selected to Whitelist</span>”.",
        ],
      },
      {
        popupTitle: "Clean up — space is for the chosen!",
        subTitle:
          "HOW TO ADD USERS TO THE WHITELIST: <span class='text-primary-orange'>STEP 3</span>",
        subContent: [
          "Check the “<span class='text-primary-orange'>Listed</span>” tab to see added wallets. To remove wallets, select up to <span class='text-primary-red'>70</span> and click “<span class='text-primary-orange'>Remove Selected from Whitelist</span>”.",
        ],
      },
    ],
  },
];
